import { net } from "./pb";
import { Toast } from "vant";
import EventBus from "@/uitls/EventBus";
import IMUtils from "./imUtils";
import { msg_get_group_info, msg_get_msg_list, msg_confirm_read_msg, msg_get_offline_data } from "./SocketReq";
import { imMessageListModel, imChatModel, imUserModel, imFriendListModel, imGroupListModel } from "@/model/chatModel"
import Storage from "@/uitls/Storage";
import {
  addImfriend,
  addImGroup,
  addImUser,
  clearServe,
  createChat,
  createIMList,
  getChatLast,
  getdataImChat,
  getIMFriend,
  getImfriendItem,
  getImGroupItem,
  getIMGrouplist,
  getIMListAll,
  getIMListItem,
  getImUser,
  updateImChat,
  updateImfriendItem,
  updateImGroupItem,
  updateIMList,
  updateImMsgRead,
  updateImUser
} from "@/network/db/dbServe"
import { deviceid } from "@/uitls/uitls";
import i18n from "@/i18n";
import Platform from "@/config/platform";
const { t } = i18n.global;

const normalizeUid = (uid: unknown) => uid == null ? "" : String(uid);
const isSameUid = (uid1: unknown, uid2: unknown) => normalizeUid(uid1) === normalizeUid(uid2);

export default function SocketRes(cmd: net.CLIENT_MSG_ID, body: any) {
  if (cmd == 1000) {
    //心跳不用管
    //console.log("心跳");

    return;
  }
  if (process.env.NODE_ENV == 'development') {
    console.log('res---cmd---', cmd);
  }
  switch (cmd) {
    case net.CLIENT_MSG_ID.S2C_MSG_H5LOGIN_REP:
      msg_login_rep(body);
      return;
    case net.CLIENT_MSG_ID.S2C_MSG_JOIN_CHATROOM_REP:
      msg_join_chatroom_rep(body);
      return;
    case net.CLIENT_MSG_ID.S2C_MSG_GET_CHATROOM_HISTORY_MSG_REP:
      msg_get_chatroom_htstory_msg_rep(body);
      return;
    case net.CLIENT_MSG_ID.S2C_MSG_SEND_CHATROOM_MSG_REP:
      msg_send_chatroom_msg_rep(body);
      return;
    case net.CLIENT_MSG_ID.S2C_MSG_JOIN_CHATROOM_NTY:
      msg_join_chatroom_nty(body);
      return;
    case net.CLIENT_MSG_ID.S2C_MSG_RED_NTY:
      S2C_MSG_RED_NTY(body);
      return;
    case net.CLIENT_MSG_ID.S2C_MSG_GET_MSG_LIST_REP:
      msg_get_msg_list_rep(body);
      return;
    case net.CLIENT_MSG_ID.S2C_MSG_GET_HASREAD_LIST_REP:
      msg_get_hasread_list(body);
      return;
    case net.CLIENT_MSG_ID.S2C_MSG_GET_USER_INFO_REP:
      msg_get_user_info_rep(body);
      return;
    case net.CLIENT_MSG_ID.S2C_MSG_GET_GROUP_INFO_REP:
      msg_get_group_info_rep(body);
      return;
    case net.CLIENT_MSG_ID.S2C_MSG_SEND_PRIVATE_MSG_REP:
      msg_send_private_msg_rep(body);
      return;
    case net.CLIENT_MSG_ID.S2C_MSG_SEND_GROUP_MSG_REP:
      msg_send_group_msg_rep(body);
      return;
    case net.CLIENT_MSG_ID.S2C_MSG_FRIEND_APPLY_LIST_REP:
      msg_friend_apply_list_rep(body);
      return;
    case net.CLIENT_MSG_ID.S2C_MSG_FRIEND_LIST_REP:
      msg_friend_list(body);
      return;
    case net.CLIENT_MSG_ID.S2C_MSG_HANDLE_FRIEND_APPLY_REP:
      msg_handle_friend_apply_rep(body);
      return;
    case net.CLIENT_MSG_ID.S2C_MSG_DEL_CHATROOM_MSG_REP:
      msg_del_chatroom_msg_rep(body);
    case net.CLIENT_MSG_ID.S2C_MSG_CONFIRM_READ_MSG_REP:
      msg_confirm_read_msg_rep(body);
      return;
    case net.CLIENT_MSG_ID.S2C_MSG_SEND_CHATROOM_AD_REP:
      msg_send_chatroom_ad_rep(body);
      return;
    case net.CLIENT_MSG_ID.S2C_MSG_CONFIRM_HASREAD_MSG_REP:
      msg_confirm_hasread_msg_rep(body);
      return;
    case net.CLIENT_MSG_ID.S2C_MSG_GET_ONLINE_STATE_REP:
      msg_get_online_state(body);
      return;
    case net.CLIENT_MSG_ID.S2C_MSG_SET_SIGN_REP:
      msg_set_sign_rep(body);
      return;
    case net.CLIENT_MSG_ID.S2C_MSG_SET_HEADURL_REP:
      msg_set_headurl_rep(body);
      return;
    case net.CLIENT_MSG_ID.S2C_MSG_PHP_MSGBOX_NTY:
      msg_php_msgbox_nty(body);
      return;
    case net.CLIENT_MSG_ID.S2C_MSG_GROUP_BASE_NTY:
      msg_group_base_nty(body);
      return;
    case net.CLIENT_MSG_ID.S2C_MSG_LOGIN_OTHER_NTY:
      msg_login_other_nty(body);
      return;
    case net.CLIENT_MSG_ID.S2C_MSG_NEED_READ_GROUP_NOTIFY_REP:
      msg_need_read_group_notify(body);
      return;
    case net.CLIENT_MSG_ID.S2C_MSG_USER_INFO:
      msg_user_data_rep(body);
      return;
    default:
      return;
  }
}

const msg_need_read_group_notify = async (body) => {
  const msg = net.msg_need_read_group_notify_rep.decode(body);
  if (msg.is_need == 1) {
    EventBus.emit("event_show_notice", true);
  }
}

const msg_login_other_nty = async (body) => {
  const msg = net.msg_login_other_nty.decode(body);
  const dvd = IMUtils.decode(msg.deviceid);
  console.log("msg_login_other_nty", dvd);
  if (dvd == deviceid("deviceid")) {
    window.$Socket.close();
  }
}
// 全部群聊
const msg_group_base_nty = async (body) => {
  const msg = net.msg_group_base_nty.decode(body);
  let grouplist = msg.grouplist;

  let imGroupList = await getIMGrouplist();
  let getGroup = function (groupkey: string) {
    for (let i = 0; i < imGroupList.length; i++) {
      if (imGroupList[i].groupkey == groupkey) {
        return imGroupList[i];
      }
    }
  }

  let keys = [];
  let index = 0;
  for (let i in grouplist) {
    // 把所有群都查一遍
    let groupkey = grouplist[i].groupkey;
    let group = getGroup(groupkey + "");

    if (group) {
      if (group.attrversion < grouplist[i].attrversion || group.member_cnt != grouplist[i].member_cnt) {
        keys.push(groupkey);
      }
      if (group.chatmsgno < grouplist[i].chatmsgno) {
        msg_get_msg_list(groupkey, group.chatmsgno);
      }
      // 属性没有变化不需要更新
      if (group.attrversion < grouplist[i].attrversion) {
        msg_get_group_info(groupkey);
      }
    } else {
      keys.push(groupkey);
      setTimeout(() => {
        msg_get_msg_list(groupkey, 0);
      }, 50 * index);
    }
  }
  // 对比消息版本号，拉取群消息
  for (let i = 0; i < keys.length; i++) {
    const element = keys[i];
    setTimeout(() => {
      msg_get_group_info(element);
    }, 50 * i);
  }
};
//进球通知
const msg_php_msgbox_nty = (body) => {
  const msg = net.msg_php_msgbox_nty.decode(body);
  const content = IMUtils.decode(msg.content)
  const message = JSON.parse(content);
  EventBus.emit("msgbox", message);

}
//设置个性签名回调
const msg_set_sign_rep = (body) => {
  const msg = net.msg_set_sign_rep.decode(body);
  if (msg.result == 1) {
    EventBus.emit("changeSignSuccecc");
  }

}
//设置头像回调
const msg_set_headurl_rep = (body) => {
  const msg = net.msg_set_headurl_rep.decode(body);
  if (msg.result == 1) {
    EventBus.emit("changeAvatarSuccecc");
  }

}
//在线状态回调 
const msg_get_online_state = (body) => {
  let msg = net.msg_get_online_state_rep.decode(body);
  console.log(msg);
}


//已读回调
async function msg_confirm_hasread_msg_rep(body) {
  let msg = net.msg_confirm_hasread_msg_rep.decode(body);
  // console.log('已读回调',msg.chatmsgno_list);
  if (!msg.chatmsgno_list || msg.chatmsgno_list.length === 0) {
    return;
  }
  await updateImMsgRead(msg.chatkey.toString(), msg.chatmsgno_list);
  EventBus.emit("imchatRad", msg);
  EventBus.emit("imlist");
}

//直播间聊天广告
const msg_send_chatroom_ad_rep = async (body) => {
  let msg: any = net.msg_send_chatroom_ad_rep.decode(body);
  const content = IMUtils.decode(msg.content)
  const messageAd = JSON.parse(content);
  console.log('直播间聊天广告', msg, msg.msgtype);

  //1是房间里面聊天里面，2是房间视频上面一张图，还有个倒计时，3是创建了一个聊天会话，房间里面那个消息来了的动画也要弹出来
  //聊天内容
  if (messageAd.adType == 1) {
    EventBus.emit("messageAd", messageAd);
  } else if (messageAd.adType == 3) {
    const user = messageAd.chat_ids[Math.floor(Math.random() * messageAd.chat_ids.length)];
    const chatkey = IMUtils.createChatKey(user.uid).toString()
    //新增私聊
    //检查一下，有没有这个私聊记录
    const res = await getChatLast(chatkey)
    //私聊是存在的，只需要把chatmsgno +1
    let chat = {} as imChatModel;
    chat.content = messageAd.content;
    chat.uid = user.uid;
    chat.time = new Date().getTime();
    chat.headurl = user.headurl
    chat.nickname = user.name
    chat.clientkey = "h5"
    chat.chatkey = chatkey;
    chat.msgtype = msg.msgtype;
    chat.chatmsgno = res ? res.chatmsgno + 1 : 1
    chat.read = true;
    await createChat(chat)

    //新增聊天会话
    const val = await getIMListItem(chatkey)
    if (val) {
      //去更新
      val.content = messageAd.content;
      val.headurl = user.headurl
      val.nickname = user.name;
      val.msgtype = msg.msgtype
      val.time = new Date().getTime();
      val.red++
      val.isGroup = false;
      const v = await updateIMList(chatkey, val)
      if (v) {
        EventBus.emit("imlist");
        EventBus.emit("roomNewimlist");
        EventBus.emit("layoutRed");
        EventBus.emit("imchat", chatkey);
      }


    } else {
      let user2 = {} as imMessageListModel;
      user2.headurl = user.headurl
      user2.content = messageAd.content;
      user2.uid = user.uid;
      user2.chatkey = chatkey;
      user2.msgtype = msg.msgtype;
      user2.time = new Date().getTime();
      user2.nickname = user.name;
      user2.red = 1;
      user2.isGroup = false;
      const v = await createIMList(user2)
      if (v) {
        EventBus.emit("imlist");
        EventBus.emit("roomNewimlist");
        EventBus.emit("layoutRed");
        EventBus.emit("imchat", chatkey);
      }
    }

  } else if (messageAd.adType == 2) {
    EventBus.emit("roomPlayAd", messageAd);
  }
}

//确认拉取的回调
const msg_confirm_read_msg_rep = (body) => {
  // const msg = net.msg_confirm_read_msg_rep.decode(body);
  // console.log("确认拉取成功",msg);
}
const msg_del_chatroom_msg_rep = (body) => {
  const msg = net.msg_del_chatroom_msg_rep.decode(body);
  EventBus.emit("roomDelMsg", msg.msgno);
}
//同意或者拒绝好友的返回
const msg_handle_friend_apply_rep = (body) => {
  let msg = net.msg_handle_friend_apply_rep.decode(body);
  EventBus.emit("newFriendRes");
}

//好友列表数据
const msg_friend_list = async (body) => {
  const myUid = Storage.get('uid');
  try {
    let msg = net.msg_friend_list_rep.decode(body);


    let list = msg.flist;
    let index;
    let index2;
    for (let i = 0; i < list.length; i++) {
      let item = list[i];
      if (item.fid == 85622665) {
        index = i;
      }

      if (item.uid == myUid) {
        index2 = i;
      }
    }
    if (index != null) {
      list.splice(index, 1)
    }
    if (index2 != null) {
      list.splice(index2, 1)
    }

    const friendList = await getIMFriend()
    //去重
    let result = list.filter(function (item1) {
      return friendList.every(function (item2) {
        const headurl = IMUtils.decode(item1.headurl);
        const nickname = IMUtils.decode(item1.nickname);
        return item2.headurl !== headurl || item2.nickname !== nickname
      })
    })

    for (let j = 0; j < result.length; j++) {
      const fitem = result[j];
      if (fitem.fid == 0) {
        break;
      }

      let obj = {} as imFriendListModel;
      obj.fid = fitem.fid
      obj.headurl = IMUtils.decode(fitem.headurl);
      obj.nickname = IMUtils.decode(fitem.nickname);
      obj.uid = fitem.uid;
      obj.phonenum = IMUtils.decode(fitem.phonenum);
      obj.lastlogouttime = fitem.lastlogouttime;
      obj.type = fitem.usertype;
      const v = await getImfriendItem(obj.uid)

      if (v) {
        updateImfriendItem(obj.uid, obj)
      } else {
        addImfriend(obj)
      }

    }

    if (result.length > 0) {
      // console.log("myfriend",result);

      EventBus.emit("myfriend");
    }

  } catch (error) {
    console.log("好友列表数据有问题");

  }


}
//好友申请列表数据
const msg_friend_apply_list_rep = (body) => {
  let msg = net.msg_friend_apply_list_rep.decode(body);
  let list = msg.apply_list;

  for (let i = 0; i < list.length; i++) {
    let item = list[i];
    item.hellomsg = IMUtils.decode(item.hellomsg)
    item.info.nickname = IMUtils.decode(item.info.nickname)
    item.info.headurl = IMUtils.decode(item.info.headurl)
  }
  EventBus.emit("newFriend", list);
  EventBus.emit("newFriend2", list);

}

//发送群消息回调
const msg_send_group_msg_rep = async (body) => {
  let msg = net.msg_send_group_msg_rep.decode(body);
  if (!msg.msg_info) {
    return;
  }
  let d = msg.msg_info;
  d.chatkey = d.chatkey.toString()
  if (!IMUtils.isGroup(d.chatkey)) {
    //不是群
    return;
  }
  //处理私聊消息
  let chat = {} as imChatModel;
  chat.content = IMUtils.decode(d.content);
  chat.uid = d.uid;;
  chat.time = d.msgtime;
  chat.headurl = IMUtils.decode(d.headurl)
  chat.nickname = IMUtils.decode(d.nickname)
  chat.clientkey = IMUtils.decode(d.clientkey)
  chat.chatkey = d.chatkey;
  chat.msgtype = d.msgtype;
  chat.chatmsgno = d.chatmsgno
  // console.log('接收回调 chat.chatkey',chat);
  await createChat(chat);
  EventBus.emit("imchat", chat.chatkey);

  const imItem: imMessageListModel = await getIMListItem(chat.chatkey)
  if (imItem) {
    //在会话列表，有数据的
    imItem.content = chat.content;
    imItem.msgtype = chat.msgtype;
    imItem.time = new Date().getTime();
    updateIMList(chat.chatkey, imItem);
  }
  EventBus.emit("imlist");
}
//发送个人消息回调
export async function msg_send_private_msg_rep(body) {
  let msg = net.msg_send_private_msg_rep.decode(body);
  if (!msg.msg_info || msg.result != 1) {
    return;
  }
  let d = msg.msg_info;


  //处理私聊消息
  let chat = {} as imChatModel;
  chat.content = IMUtils.decode(d.content);
  chat.uid = d.uid;
  chat.time = d.msgtime;
  chat.headurl = IMUtils.decode(d.headurl)
  chat.nickname = IMUtils.decode(d.nickname)
  chat.clientkey = IMUtils.decode(d.clientkey)
  chat.chatkey = d.chatkey.toString();
  chat.msgtype = d.msgtype;
  chat.chatmsgno = d.chatmsgno;

  // chat.read = true;
  // console.log('接收回调 chat.chatmsgno',chat.chatmsgno);
  await createChat(chat);
  EventBus.emit("imchat", chat.chatkey);

  const imItem: imMessageListModel = await getIMListItem(chat.chatkey)
  if (imItem) {
    //在会话列表，有数据的
    imItem.content = chat.content;
    imItem.msgtype = chat.msgtype;
    imItem.time = new Date().getTime();
    updateIMList(chat.chatkey, imItem);
  }
  EventBus.emit("imlist");

  msg_confirm_read_msg(d.chatkey, d.chatmsgno);
  // console.log('私聊消息回调',chat);

}

//群资料查询
const msg_get_group_info_rep = async (body) => {
  // console.log('群资料查询',1);

  let msg = net.msg_get_group_info_rep.decode(body);
  if (msg.group_info) {
    let groupname: string = IMUtils.decode(msg.group_info.groupname);
    const groupkey = msg.group_info.groupkey
    if (!groupname || groupname.length == 0) {
      let userList = msg.users.slice(0, 5);
      const val: imMessageListModel = await getIMListItem(groupkey.toString())
      if (val) {
        if (!!!val.nickname) {
          //自己处理name
          for (let i = 0; i < userList.length; i++) {
            const element = userList[i];
            const nickname = IMUtils.decode(element.nickname);
            groupname = groupname + "," + nickname;
          }
          groupname = groupname.substring(1, groupname.length);
          val.nickname = groupname;
        }
        val.headurl = IMUtils.decode(msg.group_info.groupheadurl);
        updateIMList(groupkey.toString(), val)
      }
    }

    let arr = msg.group_info;
    let obj = {} as imGroupListModel;
    obj.groupkey = arr.groupkey + "";
    obj.chatkey = arr.groupkey + "";
    obj.headurl = IMUtils.decode(arr.groupheadurl);
    obj.nickname = groupname;
    obj.groupnotify = IMUtils.decode(arr.groupnotify);
    obj.chatmsgno = arr.chatmsgno;
    obj.attrversion = arr.attrversion;
    obj.grouphost = arr.grouphost;
    obj.groupadmins = arr.groupadmins;
    obj.admins = arr.admins;
    obj.info_limits = arr.info_limits;
    obj.add_limits = arr.add_limits;
    obj.look_limits = arr.look_limits;
    obj.member_cnt = arr.member_cnt;
    obj.send_msg_limits = arr.send_msg_limits;
    obj.notifyversion = arr.notifyversion;
    obj.forbidbegintm = arr.forbidbegintm;
    obj.forbidendtm = arr.forbidendtm;
    obj.isforbid = arr.isforbid;
    obj.forbid_uids = IMUtils.decode(arr.forbid_uids);
    obj.white_uids = IMUtils.decode(arr.white_uids);

    let g = await getImGroupItem(groupkey);
    if (g) {
      await updateImGroupItem(groupkey, obj);
    } else {
      await addImGroup(obj);
    }

    let cv = await getIMListItem(groupkey.toString());
    if (cv && cv.nickname != groupname) {
      cv.nickname = groupname;
      await updateIMList(groupkey.toString(), cv);
    }

    EventBus.emit("updateGroup", { chatkey: groupkey, url: obj.headurl, name: obj.nickname });
  }
}

//未读消息
const msg_get_hasread_list = async (body) => {
  let msg = net.msg_get_hasread_list_rep.decode(body);
  if (!msg.chatmsgno_list || msg.chatmsgno_list.length === 0) {
    return;
  }
  await updateImMsgRead(msg.chatkey.toString(), msg.chatmsgno_list);
  EventBus.emit("imchatRad", msg);
  EventBus.emit("imlist");
}
//查询用户信息返回
const msg_get_user_info_rep = async (body) => {
  let msg = net.msg_get_user_info_rep.decode(body);
  if (msg.user_info != null && msg.user_info.uid != 0) {
    const userInfo = msg.user_info
    const headurl = IMUtils.decode(userInfo.headurl);
    const phonenum = IMUtils.decode(userInfo.phonenum);
    const nickname = IMUtils.decode(userInfo.nickname);
    // 看一下用户表有没有这个人的资料
    let user: imUserModel = await getImUser(msg.user_info.uid)

    if (user) {
      //如果有，就去更新
      user.headurl = headurl;
      user.phonenum = phonenum;
      user.fid = msg.user_info.fid;
      user.nickname = nickname;
      user.usertype = msg.user_info.usertype;
      user.lastlogouttime = msg.user_info.lastlogouttime;
      updateImUser(user.uid, user);
      EventBus.emit("imchatUser", { fid: user.fid, uid: user.uid, is_new: false});
    } else {
      //没有，新建
      let item = {} as imUserModel;
      item.headurl = headurl;
      item.phonenum = phonenum;
      item.fid = msg.user_info.fid;
      item.nickname = nickname;
      item.uid = msg.user_info.uid;
      item.usertype = msg.user_info.usertype;
      item.lastlogouttime = msg.user_info.lastlogouttime;
      addImUser(item);
      EventBus.emit("imchatUser", { fid: item.fid, uid: item.uid, is_new: true});

    }
  }

}


//拉取新的消息 接收新消息 查询个人/群的消息，从第几条开始领取
const msg_get_msg_list_rep = async (body) => {
  let msg = net.msg_get_msg_list_rep.decode(body);
  if (msg.msg_list.length == 0) {
    return;
  }
  const rawMsgList = msg.msg_list;
  const lastRawMsg = rawMsgList[rawMsgList.length - 1];
  const msgList = rawMsgList
    .filter((item) => item.msgtype !== 17)
    .map((item) => {
      if (item.msgtype === 14) {
        item.msgtype = 1;
      }
      return item;
    });

  if (msgList.length == 0) {
    msg_confirm_read_msg(lastRawMsg.chatkey, lastRawMsg.chatmsgno);
    return;
  }
  const lastMsg = msgList[msgList.length - 1]; //最后一条可展示消息

  const myUid = Storage.get('uid');
  let lastname = "";
  let lastcontent = "";
  let unreadnum = 0;
  //新增所有聊天
  for (let j = 0; j < msgList.length; j++) {
    const dataItem = msgList[j];
    let chat = {} as imChatModel;
    chat.content = IMUtils.decode(dataItem.content);
    chat.uid = dataItem.uid;
    chat.time = dataItem.msgtime;
    chat.headurl = IMUtils.decode(dataItem.headurl)
    chat.nickname = IMUtils.decode(dataItem.nickname)
    chat.clientkey = IMUtils.decode(dataItem.clientkey)
    chat.chatkey = dataItem.chatkey.toString();
    chat.msgtype = dataItem.msgtype;
    chat.chatmsgno = dataItem.chatmsgno
    chat.read = false;

    lastname = chat.nickname;
    lastcontent = chat.content;

    let logindata = await getdataImChat(chat.chatkey, chat.chatmsgno);
    if (!logindata) {
      unreadnum++;
    }
    await createChat(chat);

    if (j == msgList.length - 1) {
      msg_confirm_read_msg(lastRawMsg.chatkey, lastRawMsg.chatmsgno);
    }
  }

  EventBus.emit("imchat", lastMsg.chatkey.toString());
  if (window.Notification && Notification.permission !== "denied") {
    Notification.requestPermission(function (status) {
      if (status === "granted") {
        var n = new Notification(lastname, { body: lastcontent });
      }
    });
  }



  // 更新会话显示
  if (IMUtils.isGroup(lastMsg.chatkey)) {
    //群聊
    const val: imMessageListModel = await getIMListItem(lastMsg.chatkey.toString())
    if (val) {
      //去更新
      val.content = IMUtils.decode(lastMsg.content);
      val.msgtype = lastMsg.msgtype;
      val.isGroup = true;
      val.red = val.red + unreadnum;
      val.time = lastMsg.msgtime;
      const v = await updateIMList(lastMsg.chatkey.toString(), val);
      if (v) {
        EventBus.emit("imlist");
        EventBus.emit("layoutRed");
      }

      //还是要处理一下名字和头像
      msg_get_group_info(lastMsg.chatkey);

    } else {
      let user = {} as imMessageListModel;
      user.content = IMUtils.decode(lastMsg.content);
      // user.headurl = IMUtils.decode(lastMsg.headurl)
      // user.nickname = IMUtils.decode(lastMsg.nickname);
      user.chatkey = lastMsg.chatkey.toString();
      user.msgtype = lastMsg.msgtype;
      user.isGroup = true;
      user.red = 1;
      user.time = lastMsg.msgtime
      // console.log(user);

      const v = await createIMList(user)

      EventBus.emit("imlist");
      EventBus.emit("layoutRed");
      //还是要处理一下名字
      msg_get_group_info(lastMsg.chatkey);

    }
  } else {
    //私聊 
    const val = await getIMListItem(lastMsg.chatkey.toString());
    if (val) {
      //去更新
      if (!isSameUid(lastMsg.uid, myUid)) {
        val.content = IMUtils.decode(lastMsg.content);
        val.headurl = IMUtils.decode(lastMsg.headurl)
        val.nickname = IMUtils.decode(lastMsg.nickname);
        val.msgtype = lastMsg.msgtype
        val.time = lastMsg.msgtime
        val.red = val.red + unreadnum;
        val.isGroup = false;
        val.chatmsgno = lastMsg.chatmsgno;
        const v = await updateIMList(lastMsg.chatkey.toString(), val)
        if (v) {
          EventBus.emit("imlist");
          EventBus.emit("roomNewimlist");
          EventBus.emit("showPalyNewMsgAnimation", val);
          EventBus.emit("layoutRed");
        }
      }
    } else {

      if (!isSameUid(lastMsg.uid, myUid)) {
        let user = {} as imMessageListModel;
        user.headurl = IMUtils.decode(lastMsg.headurl)
        user.content = IMUtils.decode(lastMsg.content);
        user.uid = lastMsg.uid;
        user.chatkey = lastMsg.chatkey.toString();
        user.msgtype = lastMsg.msgtype;
        user.time = lastMsg.msgtime
        user.nickname = IMUtils.decode(lastMsg.nickname);
        user.red = unreadnum;
        user.isGroup = false;
        user.chatmsgno = lastMsg.chatmsgno;
        const v = await createIMList(user)
        if (v) {

          EventBus.emit("imlist");
          EventBus.emit("roomNewimlist");
          EventBus.emit("showPalyNewMsgAnimation", user);
          EventBus.emit("layoutRed");
          EventBus.emit("imchat", lastMsg.chatkey.toString());
        }
      }


    }
    //回话列表end
  }



}


//私聊消息进来了
const S2C_MSG_RED_NTY = async (body) => {
  let msg = net.msg_red_nty.decode(body);
  let red = msg.red;


  //1私聊，2群聊，3群属性变更，4好友申请

  if (red.redtype === 1 || red.redtype === 2) {

    //处理私聊详情
    const res = await getChatLast(red.chatkey.toString())
    let chatmsgno = 0;
    if (res) {
      chatmsgno = res.chatmsgno;
    }
    msg_get_msg_list(red.chatkey, chatmsgno)
  }
  else if (red.redtype === 3) {

  } else if (red.redtype == 4) {
    EventBus.emit("newFriendNum", red.unread_apply_num);
    EventBus.emit("newFriendNum1", red.unread_apply_num);

  }
}

//直播间消息进来了
const msg_send_chatroom_msg_rep = (body) => {
  var msg = net.msg_send_chatroom_msg_rep.decode(body);
  console.log(msg);

  if (msg.result == 36) {
    Toast.fail(t('tips.yybtcql'));
    return;
  } else if (msg.result == 38) {
    Toast.fail(t('tips.yybjy'));
    return;
  } else if (msg.result == 39) {
    Toast.fail(t('tips.ltsbcz'));
    return;
  } else if (msg.result == 45) {//聊天受限
    Toast.fail(t('您的聊天已受限，请联系主播或客服'));
    return;
  }
  if (msg.result != 1) {
    Toast.fail(t('发送失败，未知错误'));
    return;
  }

  let d = msg.msg_info;
  if (d && d.content) {
    d.content = IMUtils.decode(d.content);
    d.nickname = IMUtils.decode(d.nickname);

    d.headurl = IMUtils.decode(d.headurl);
  }
  EventBus.emit("ChatRoomMsgItem", { data: d, result: msg.result });
};

const msg_login_rep = async (body) => {
  const msg = net.msg_login_rep.decode(body);

  //for (let i = 0; i < msg.customer_list.length; i++) {
  //  const element = msg.customer_list[i];
  // if (element.customer_type == 1) {
  //    Platform.serverId = element.uid
  //  }
  //}

  if (msg.result != 1) {
    Toast.fail("err");
    return;
  }
  clearServe();
  await getIMListAll();
  //通知可以加入直播间了
  console.log("h5login成功");
  msg_get_offline_data()

  // EventBus.emit("JoinRoom");
};

//通知xxx进入了直播间
const msg_join_chatroom_nty = (body) => {
  let msg = net.msg_join_chatroom_nty.decode(body);
  msg.base_data.nickname = IMUtils.decode(msg.base_data.nickname);
  EventBus.emit("msg_join_chatroom_nty", msg);
};

const msg_join_chatroom_rep = (body) => {
  
  const msg = net.msg_join_chatroom_rep.decode(body);
  console.log("msg_join_chatroom_rep", msg);
  if (msg.result == 1 || msg.result == 35) {
    //加入直播间成功
    msg.room_info.roomname = IMUtils.decode(msg.room_info.roomname);
    EventBus.emit("JoinRoomSuccess", msg);
  } else {
    EventBus.emit("JoinRoomFail");
    EventBus.emit("JoinRoomSuccess", msg);
  }
};

//聊天室记录
const msg_get_chatroom_htstory_msg_rep = (body) => {
  const msg = net.msg_get_chatroom_history_msg_rep.decode(body);
  const msgList = msg.msg_list;
  for (let i = 0; i < msgList.length; i++) {
    msgList[i].content = IMUtils.decode(msgList[i].content);
    msgList[i].nickname = IMUtils.decode(msgList[i].nickname);
  }


  EventBus.emit("RoomMsgList", msgList);
};


const msg_user_data_rep = (body) => {
  const msg = net.msg_user_data_rep.decode(body);
  // msg.base_data.coin
  console.log('msg_user_data_rep', msg.base_data);
  Platform.isLoginIM = true;
  EventBus.emit("JoinRoom");
};
